import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "role-wrapper"
};
import { ref, computed } from 'vue';
import RoleTag from './RoleTag.vue';
import RolePicker from './RolePicker.vue';
import { useFormDisabled, useFormSize } from 'element-plus';
export default {
  __name: 'index',
  props: {
    modelValue: {
      type: [String, Array],
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择角色'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const $props = __props;
    const $emits = __emit;
    const valueArr = computed(() => {
      if (!$props.modelValue) return [];
      return Array.isArray($props.modelValue) ? $props.modelValue : [$props.modelValue];
    });
    const RolePickerRef = ref();
    const formDisabled = useFormDisabled();
    const formSize = useFormSize();
    const disabled = computed(() => {
      return formDisabled.value || $props.disabled;
    });
    const openRolePicker = () => {
      RolePickerRef.value?.open();
    };
    const onClose = id => {
      if (!$props.modelValue) return;
      if ($props.multiple && Array.isArray($props.modelValue)) {
        const newValue = $props.modelValue.filter(s => String(s) !== String(id));
        $emits('update:modelValue', newValue);
      } else {
        $emits('update:modelValue', null);
      }
    };
    return (_ctx, _cache) => {
      const _component_Avatar = _resolveComponent("Avatar");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_text = _resolveComponent("el-text");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(RolePicker, {
        ref_key: "RolePickerRef",
        ref: RolePickerRef,
        multiple: __props.multiple,
        "model-value": __props.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event))
      }, null, 8, ["multiple", "model-value"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
        class: "role-but-item",
        size: _unref(formSize),
        disabled: disabled.value,
        onClick: openRolePicker,
        circle: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Avatar)]),
          _: 1
        })]),
        _: 1
      }, 8, ["size", "disabled"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueArr.value, item => {
        return _openBlock(), _createBlock(RoleTag, {
          closable: !disabled.value,
          key: item,
          id: item,
          onClose: onClose
        }, null, 8, ["closable", "id"]);
      }), 128)), _withDirectives(_createVNode(_component_el_text, {
        class: "placeholder"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.placeholder), 1)]),
        _: 1
      }, 512), [[_vShow, !_ctx.value || _ctx.value.length === 0]])])], 64);
    };
  }
};